<template>
  <div class="ly-table">
    <div class="ly-title">
      <h3 class="title-table">
        <slot></slot>
      </h3>
      <div class="table-toggle" v-if="toggle === true">
        <i class="el-icon-arrow-up" @click="clickToggle"></i>
      </div>
    </div>
    <div ref="content">
      <div>
          <el-select
            size="medium"
            v-model="wrkTypeCd"
            :placeholder="$t('messages.plSelect')"
            :disabled="!isWrite"
          >
            <el-option
              v-for="item in wrkTypeCdList"
              :key="item.dataCode"
              :label="item.codeName"
              :value="item.dataCode"
            >
              <template>
                <el-tooltip placement="right" :content="item.string">
                  <span style="display:inline-block;width:100%;">
                    {{item.codeName}}
                  </span>
                </el-tooltip>
              </template>
            </el-option>
          </el-select>
      </div>
      <div class="btn-box" v-if="this.isWrite && !$isMobile()">
        <el-button type="primary" @click="onSave" v-if="isWrite">{{
          $t("messages.btnSave")
        }}</el-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
  },
  props: {
    hasButton: {
      // 22.03.14 누락사항 반영
      value: Boolean,
      dafault: false,
    },
    openToggle: {
      value: Boolean,
      dafault: false,
    },
    isWrite: {
      type: Boolean,
      default: true,
    },
    isTemplate: {
      type: Boolean,
      default: false,
    },
    defaultValue: {
      type: Object,
      default: () => {},
    },
    prcssTrtDataCnctId: {
      type: String,
      default: "",
    },
    exeWflowId: {
      type: String,
      default: "",
    },
    idcCd: {
      type: String,
      default: "",
    },
    ticketInfo: {
      type: Object,
      default: () => {},
    },
    //상위 공정 ID
    mainPrcssId: {
      type: String,
      default: "",
    },
    //하위 공정 ID
    subPrcssId: {
      type: String,
      default: "",
    },
    scrnId: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    scrnGetApi: {
      type: String,
      default: "",
    },
    scrnPostApi: {
      type: String,
      default: "",
    },
    scrnPutApi: {
      type: String,
      default: "",
    },
    scrnDeleteApi: {
      type: String,
      default: "",
    },
    wflowScrnId: {
      type: String,
      default: "",
    },
    mandDataChkYn: {
      type: String,
      default: "N",
    },
    sftyChkMandChkYn: {
      type: String,
      default: "N",
    },
    sftyChkScrnYn: {
      type: String,
      default: "N",
    },
    callDate: {
      type: Number,
      default: -1,
    },
    stepCd: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      toggleData: true,
      toggle: this.openToggle,
      form: {
        data: {},
      },
      wrkTypeCd: "",
      wrkTypeCdList: [],
      isSave : false,
      currPrcssTrtDataCnctId: "",
    };
  },
  mounted() {
    this.getWrkCodeList();
    this.getWrkCode(true);
  },
  watch: {
    prcssTrtDataCnctId() {
      this.getWrkCode(true);
    }
  },
  methods: {
    clickToggle(e) {
      if (this.toggleData) {
        this.$refs.content.style = "display: none";
        e.target.className = "el-icon-arrow-down";
      } else {
        this.$refs.content.style = "display: block;";
        e.target.className = "el-icon-arrow-up";
      }
      this.toggleData = this.toggleData ? false : true;
    },
    //조회
    async getWrkCode(initFlag) {
      if (initFlag) {
        if (this.prcssTrtDataCnctId != null && this.prcssTrtDataCnctId != "") {
          this.currPrcssTrtDataCnctId = this.prcssTrtDataCnctId
        }
      }
      await this.$BIZ_SERVICE
        .post(this.$API_URLS.Wrk.getWrkTimeCode, { prcssTrtDataCnctId : this.currPrcssTrtDataCnctId }) //getWrkTimeCode
        .then((res) => {
          if(res.data.resData.wrkSrRegBasInfoVO) {
            this.wrkTypeCd = res.data.resData.wrkSrRegBasInfoVO.srType;
            this.isSave = true;
          }
        });
    },
    //조회
    getWrkCodeList() {
      this.$BIZ_SERVICE
        .post(this.$API_URLS.Com.getIcisCdList, { grpcode: '03B0' })
        .then((res) => {
          this.wrkTypeCdList = res.data.resData;
        });
    },
    //데이터 삽입
    setReqData(){

      this.form.data.exeWflowId = this.exeWflowId
      this.form.data.mainPrcssId = this.mainPrcssId
      this.form.data.subPrcssId    = this.subPrcssId
      this.form.data.stepCd = this.$store.getters['wflowStore/getWwflowCurrentStepCd']
      this.form.data.scrnId = this.scrnId
      //this.form.data.scrnActionId = this.scrnActonList //TODO 확인 필요
      this.form.data.trtrId = this.ticketInfo.trtrId
      this.form.data.ticktId = this.ticketInfo.ticktId
      this.form.data.prcssTrtDataCnctId = this.prcssTrtDataCnctId
      this.form.data.wflowScrnId = this.wflowScrnId

      this.form.data.srType = this.wrkTypeCd;
    },
    //저장
    onSave() {
      let saveUrl = "";
      saveUrl = this.$API_URLS.Wrk.postWrkTypeByPrcssTrtId;
      
      this.setReqData();

      this.$BIZ_SERVICE
        .post(saveUrl, this.form.data)
        .then((res) => {
          //저장 성공 후 공정처리연결ID 재매핑
          this.currPrcssTrtDataCnctId = res.data.resData;
          this.isSave = true;
          alert("등록되었습니다.");
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          this.getWrkCode(false);
        });
    },

    getTemplateData() {
      // 상위 컴포넌트에서 호출
      // Axios로 저장 시 넘겨줄 데이터를 리턴하면 됨.
      return this.wrkTypeCd;
    },
    chkValidateData() {
      if(this.wrkTypeCd && this.isSave) {
        return true;
      } 
      else {
        return false;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.btn-box {
  margin-top: 10px;
  display: flex;
  justify-content: flex-end;
}
.el-button {
  // 22.03.14 누락사항 반영
  margin-top: 20px;
}
@include mobile {
  .ly-table {
    padding-top: 20px !important;
  }
  .el-button {
    margin-top: 20px;
  }
}
</style>
